import { useMemo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { queryProcedureResult, getProcedureResult } from 'iguazu-rpc';
import runAsync from './runAsync';
const useProcedureResult = function (args) {
  let {
    defer = false,
    withStatus = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const dispatch = useDispatch();
  const getData = useMemo(() => getProcedureResult(args), [args]);
  const result = useSelector(getData);
  const isLoaded = !!result;
  const error = result instanceof Error ? result : undefined;
  const data = !(result instanceof Error) ? result : undefined;
  const runProcedure = useCallback(() => {
    const queryProcedure = () => {
      const {
        promise
      } = dispatch(queryProcedureResult(args));
      return promise;
    };
    return runAsync(queryProcedure, withStatus);
  }, [dispatch, args, withStatus]);
  useEffect(() => {
    if (isLoaded || defer) {
      return;
    }
    runProcedure();
  }, [isLoaded, defer, runProcedure, withStatus]);
  return useMemo(() => ({
    isLoading: !(isLoaded || defer),
    error,
    data: withStatus ? data === null || data === void 0 ? void 0 : data.data : data,
    ...(withStatus && {
      status: data === null || data === void 0 ? void 0 : data.status
    }),
    run: runProcedure
  }), [defer, withStatus, isLoaded, data, error, runProcedure]);
};
export default useProcedureResult;